"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnquiryCommentFileDto = instanceOfEnquiryCommentFileDto;
exports.EnquiryCommentFileDtoFromJSON = EnquiryCommentFileDtoFromJSON;
exports.EnquiryCommentFileDtoFromJSONTyped = EnquiryCommentFileDtoFromJSONTyped;
exports.EnquiryCommentFileDtoToJSON = EnquiryCommentFileDtoToJSON;
exports.EnquiryCommentFileDtoToJSONTyped = EnquiryCommentFileDtoToJSONTyped;
/**
 * Check if a given object implements the EnquiryCommentFileDto interface.
 */
function instanceOfEnquiryCommentFileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined)
        return false;
    return true;
}
function EnquiryCommentFileDtoFromJSON(json) {
    return EnquiryCommentFileDtoFromJSONTyped(json, false);
}
function EnquiryCommentFileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileUrl': json['fileUrl'],
        'fileName': json['fileName'],
        'fileSize': json['fileSize'],
    };
}
function EnquiryCommentFileDtoToJSON(json) {
    return EnquiryCommentFileDtoToJSONTyped(json, false);
}
function EnquiryCommentFileDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
        'fileSize': value['fileSize'],
    };
}
